import { useQuery } from "@tanstack/react-query";
import axiosClient from "../services/api/axiosInstance";
import { normalizeManagementRole } from "../constants/managementRoles";
import type { AuthProfile } from "../contexts/authProfile";

export const useMe = () =>
  useQuery<AuthProfile>({
    queryKey: ["Me"],
    queryFn: async ({ signal }) => {
      const { data } = await axiosClient.get<AuthProfile>("/api/v1/me", {
        signal,
      });
      return {
        ...data,
        management_roles: (data.management_roles || []).map(
          (role) => normalizeManagementRole(role) ?? role
        ),
      };
    },
    staleTime: Infinity,
  });
